<template>
  <v-container fluid>
    <v-flex class="margin-custom-width-left margin-custom-width-right">
      <v-layout row wrap>
        <v-flex xs12 sm8 md6>
          <v-form ref="form" v-model="valid">
            <label class="headline">Merchandise order</label>
            <v-text-field v-model="playerName" :rules="nameRules" label="Name" required></v-text-field>
            <v-text-field v-model="email" :rules="emailRules" label="Contact E-mail" required></v-text-field>
            <v-select
              label="Item"
              v-model="selectedOption"
              :rules="optionRule"
              :items="options"
              item-value="id"
              item-text="description"
              return-object
            ></v-select>
            <v-text-field
              v-show="this.selectedOption.id === 2"
              v-model="printName"
              label="Name print on Jersey"
              required
            ></v-text-field>
            <v-text-field
              v-show="this.selectedOption.id === 2"
              v-model="printNumber"
              label="Number print on Jersey"
              required
            ></v-text-field>
            <v-select label="Size" v-model="selectedSize" :rules="sizeRule" :items="sizes"></v-select>
            <v-layout row>
              <v-select
                label="Color"
                v-model="selectedColor"
                :rules="colorRule"
                :items="colors"
                item-value="id"
                item-text="color"
                return-object
              ></v-select>
              <v-dialog v-model="dialogPic" max-width="500" dark :disabled="!this.selectedColor">
                <v-btn
                  slot="activator"
                  round
                  outline
                  color="primary"
                  @click="setActiveItem"
                  :disabled="!this.selectedColor"
                >View Sample</v-btn>
                <v-card>
                  <v-card-text>
                    <v-carousel
                      hide-delimiters
                      ref="carousel"
                      v-model="carouselIndex"
                      :cycle="false"
                    >
                      <v-carousel-item v-for="(item,i) in pics" :key="i" :src="item.src"></v-carousel-item>
                    </v-carousel>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-layout>
            <v-textarea
              v-model="comments"
              label="Comments, like hurry up i'm desperate... (optional)"
              required
            ></v-textarea>

            <v-btn :disabled="!valid" @click="submit()" color="primary">Submit</v-btn>

            <v-btn @click="clear" color="info">Clear</v-btn>
            <br />
            <br />
          </v-form>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-snackbar
      v-model="snackbar.visible"
      :color="snackbar.color"
      :timeout="10000"
      multi-line
    >{{ snackbar.text }}</v-snackbar>
  </v-container>
</template>


<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import dataService from "@/data/data.service";

export default {
  data: () => ({
    snackbar: {
      text: "",
      visible: false,
      color: "success"
    },
    dialogPic: false,
    valid: true,
    carouselIndex: 0,
    selectedOption: [],
    selectedSize: null,
    selectedColor: [],
    printNumber: null,
    printName: null,
    playerName: null,
    nameRules: [v => !!v || "Name is required"],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    optionRule: [v => !!v || "Required"],
    sizeRule: [v => !!v || "Required"],
    colorRule: [v => !!v || "Required"],
    comments: "",

    options: [
      { id: 1, description: "Jersey with logo - $20" },
      { id: 2, description: "Jersey with logo + custom name and number - $25" }
    ],
    colors: [
      {
        id: 1,
        color: "White",
        status: "Available",
        disabled: false
      },
      {
        id: 2,
        color: "Pink",
        status: "Available",
        disabled: false
      },
      {
        id: 3,
        color: "Black",
        status: "Unavailable",
        disabled: true
      }
    ],
    sizes: ["Youth - Large", "Youth - XL", "Adult - Small", "Adult - Medium", "Adult - Large"],
    pics: [
      {
        src:
          "https://s3.amazonaws.com/photos.fairfaxcityfutsal.com/jersey-white-front.jpg"
      },
      {
        src:
          "https://s3.amazonaws.com/photos.fairfaxcityfutsal.com/jersey-white-back.jpg"
      }
    ]
  }),

  mounted() {},

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        let env = process.env.NODE_ENV || "development";
        let config = require("../../config")[env];
        let emailObj = {
          from: "inquiry@fairfaxcityfutsal.com",
          to: config.email.recipient,
          subject: "Jersey order",
          body:
            `Player: ${this.playerName} <br><br>` +
            `Email: ${this.email} <br><br>` +
            `Item: ${this.selectedOption.description} <br><br>` +
            `Size: ${this.selectedSize} <br><br>` +
            `Color: ${this.selectedColor.color} <br><br>` +
            `Name: ${this.printName} <br><br>` +
            `Number: ${this.printNumber} <br><br>` +
            `Comment: ${this.comments}`
        };

        dataService.modules.email.sendMail(emailObj).then(() => {
          this.printName = null;
          this.printNumber = null;
          this.snackbar.visible = true;
          this.snackbar.text =
            "Thanks, your order is submitted. We'll get back to you soon!";
        });
      }
    },
    setActiveItem() {
      this.carouselIndex = this.selectedColor.id - 1;
    },
    clear() {
      this.$refs.form.reset();
    },

    ...mapActions("ageGroup", { getAgeGroups: "get" }),
    ...mapActions("signUps", { addSignUp: "add" })
  },

  computed: {
    //...mapGetters("ageGroup", ["ageGroups"])
  }
};
</script>